import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetService = async (keyword = '', page = '', perPage = '', is_paginate = 1, status = null) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['title'] = keyword;
    }

    if (status) {
        params['status'] = status;
    }
    params['paginate'] = is_paginate;

    const response = await GET(apiUrl.service, params);
    return response;
}

export const GetServiceById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.service + '/' + id,params);
    return response;
}

export const CreateService = async (data) => {
    const response = await POST(apiUrl.service, data);
    return response;
}

export const UpdateService = async (id, data) => {
    const response = await PUT(apiUrl.service, id, data);
    return response;
}

export const DeleteService = async (id) => {
    const response = await DELETE(apiUrl.service, id);
    return response;
}
